import { noAutoReloadPaths } from 'shared/constants';

const reloadAtStorageKey = 'chunk-load-failure-reload-at';
const reloadCooldownMs = 5 * 60 * 1000;

// Safari, Chrome and Firefox each word a failed dynamic import differently.
const chunkLoadErrorMessages = [
  'Importing a module script failed',
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
];

export const isChunkLoadError = (error: unknown): boolean => {
  const message = (error as { message?: unknown } | null)?.message;
  return (
    typeof message === 'string' &&
    chunkLoadErrorMessages.some((fragment) => message.includes(fragment))
  );
};

const readLastReloadAt = (): number | null => {
  try {
    return Number(sessionStorage.getItem(reloadAtStorageKey)) || 0;
  } catch {
    return null;
  }
};

// A deploy removes the hashed chunks an open tab still points at; one reload fetches the current build.
export const reloadAfterChunkLoadFailure = (error: unknown): boolean => {
  if (!isChunkLoadError(error)) {
    return false;
  }
  const { pathname } = window.location;
  if (noAutoReloadPaths.some((path) => pathname.startsWith(path))) {
    return false;
  }

  // Without a readable guard a failure that survives the reload would loop forever.
  const lastReloadAt = readLastReloadAt();
  const now = Date.now();
  if (lastReloadAt === null || now - lastReloadAt < reloadCooldownMs) {
    return false;
  }

  try {
    sessionStorage.setItem(reloadAtStorageKey, String(now));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
};
